import React from 'react';
import {
  OutlineButton,
  PrimaryButton,
  Typography,
} from 'glints-aries/es/@next';
import { FormattedMessage } from 'react-intl';

import { useSendWhatsappVerificationToken } from '../../../../../../common/hooks/requests/useSendWhatsappVerificationToken';
import { WhatsappVerificationStep } from '../../../../../WhatsappVerification/types';
import { useWhatsappVerificationContext } from '../../../../../WhatsappVerification/WhatsappVerificationContext/WhatsappVerificationContext';
import { FORM_ID, OTP_RESEND_WAIT_TIME_IN_SECONDS } from '../../../consts';
import { StyledInputOTPFooter, StyledModalFooter } from './styles.sc';

export const InputOTPModalFooter = () => {
  const { loading, previousStep, resendOTPCountdown, setResendOTPCountdown } =
    useWhatsappVerificationContext();

  const [sendWhatsappVerificationToken] = useSendWhatsappVerificationToken();

  return (
    <StyledModalFooter>
      <StyledInputOTPFooter>
        <OutlineButton
          disabled={resendOTPCountdown !== 0}
          type="submit"
          form={FORM_ID[WhatsappVerificationStep.InputOTP]}
          onClick={e => {
            e.preventDefault();
            sendWhatsappVerificationToken({
              onError: e => console.error(e),
            });
            setResendOTPCountdown(OTP_RESEND_WAIT_TIME_IN_SECONDS);
          }}
        >
          <Typography variant="button">
            <FormattedMessage
              id="interactive-resend-code-second"
              defaultMessage="Resend Code {second, plural, =0 {} other {({second})}}"
              values={{
                second: resendOTPCountdown,
              }}
            />
          </Typography>
        </OutlineButton>
        <div>
          <OutlineButton onClick={previousStep}>
            <Typography variant="button">
              <FormattedMessage id="interactive-back" defaultMessage="Back" />
            </Typography>
          </OutlineButton>
          <PrimaryButton
            type="submit"
            form={FORM_ID[WhatsappVerificationStep.InputOTP]}
            loading={loading}
            disabled={loading}
          >
            <Typography variant="button">
              <FormattedMessage
                id="interactive-verify"
                defaultMessage="Verify"
              />
            </Typography>
          </PrimaryButton>
        </div>
      </StyledInputOTPFooter>
    </StyledModalFooter>
  );
};
